import React from "react";
import { useDispatch } from "react-redux";
import { addToastData } from "../../../redux-store/slices/toastSlice";

const deleteWarningIcon = `${EASYCOMMERCE.assets}admin/img/icons/delete-warning.png`;

const DeleteAbandonedItem = ({ setShowDeleteModal, itemHash, removeItem }) => {
    const dispatch = useDispatch();

    const deleteNow = () => {
        if (!itemHash) return;

        const url = `${EASYCOMMERCE.rest_base}/cart/abandoned/remove`;

        easycommerce_modal(true);
        setShowDeleteModal(false);

        fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-WP-Nonce": EASYCOMMERCE.nonce,
            },
            body: JSON.stringify({ hash: itemHash }),
        })
            .then((res) => res.json())
            .then((data) => {
                easycommerce_modal(false);

                if (data.success) {
                    dispatch(
                        addToastData({
                            type: "success",
                            message: data.data.message,
                        })
                    );
                    removeItem(itemHash);
                } else {
                    dispatch(
                        addToastData({
                            type: "error",
                            message: data.data.message,
                        })
                    );
                }
            })
            .catch((error) => {
                easycommerce_modal(false);
                dispatch(
                    addToastData({
                        type: "error",
                        message: "Failed to remove item.",
                    })
                );
            });
    };

    return (
        <div
            className="fixed top-0 left-0 w-screen h-screen flex items-center justify-center bg-[#00000082] 
            backdrop-blur-sm z-[999999]"
        >
            <div className="flex flex-col justify-center items-center bg-white rounded-xl px-7 pt-[50px] py-9">
                <div className="flex flex-col justify-center items-center gap-[26px] mb-[50px]">
                    <div className="w-[86px] h-[86px] flex justify-center items-center rounded-full bg-[#FF3A521A]">
                        <img
                            src={deleteWarningIcon}
                            alt="delete-warning"
                            className="w-10 h-8"
                        />
                    </div>

                    <div className="flex flex-col justify-center items-center gap-1">
                        <h3 className="font-inter font-medium text-2xl text-[#272435]">
                            Delete this item
                        </h3>
                        <p className="w-9/12 mx-auto text-center font-inter font-normal text-base text-ec-placeholder">
                            You're about to delete this abandoned item. Are you
                            sure?
                        </p>
                    </div>
                </div>

                <div className="flex justify-between items-center gap-[14px] mb-5">
                    <button
                        className="font-inter font-medium text-base border bg-[#272435] text-white border-[#272435] 
                        rounded-lg px-[50px] py-[10px]"
                        onClick={() => setShowDeleteModal(false)}
                    >
                        No, Keep it
                    </button>
                    <button
                        className="font-inter font-medium text-base text-[#272435] border border-[#272435] 
                        rounded-lg px-[50px] py-[10px] hover:bg-[#FF3A52] hover:border-[#FF3A52] hover:text-white"
                        onClick={deleteNow}
                    >
                        Yes, Delete!
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteAbandonedItem;
